import { HomeSectionDisplayCollectionResponseDto } from '@/apis/rest/generated/types'
import { StyledDivider } from '@/components/common/divider'
import { ScrollContainer } from '@/components/domains/etc'
import { HomeSectionTitle } from '@/components/domains/home'
import { Anchor } from '@/components/domains/home/Anchor'
import styles from '@/components/domains/home/new/home-display-collection-new-arrivals.module.css'
import { HomeSectionConstant } from '@/components/domains/home/new/home-section-constant'
import { NewArrivalProductList } from '@/components/domains/home/new/new-arrival-product-list'
import { FitpetMallEventEnum } from '@/constants/fitpet-mall-event.enum'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import ROUTES from '@/constants/legacy/constRoutes'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import { useIntersectionObserver } from '@/containers/hooks'
import { Base64ConverterUtil } from '@/utils/base64-converter.util'

interface HomeDisplayCollectionNewArrivalsProps {
  homeSectionItem: HomeSectionDisplayCollectionResponseDto
  refCallback: (node: HTMLDivElement) => void
}

export const HomeDisplayCollectionNewArrivals = ({
  homeSectionItem,
  refCallback,
}: HomeDisplayCollectionNewArrivalsProps) => {
  if (!homeSectionItem.displayCollection) {
    return null
  }

  if (!homeSectionItem.products || homeSectionItem.products.length < HomeSectionConstant.MinItemCount) {
    return null
  }

  const tracker = useTracker()
  const { displayOrder, displayCollection, firstRowProducts, secondRowProducts } = homeSectionItem

  const title = displayCollection.name
  const list = [...(firstRowProducts ?? []), ...(secondRowProducts ?? [])]

  const { elementRef } = useIntersectionObserver(
    () => {
      tracker.triggerCustomEvent(FitpetMallEventEnum.ViewHomeSection, { sectionName: title })
    },
    { rootMargin: '0px' }
  )

  const seeMoreLink = {
    pathname: ROUTES.SECTION_DETAIL,
    query: {
      displayCollectionId: Base64ConverterUtil.convertNumberIdToBase64ByKey({
        key: 'DisplayCollectionType',
        id: displayCollection?.id,
      }),
      title,
    },
  }

  return (
    <>
      <Anchor id={title} refCallback={refCallback} />
      <div ref={elementRef} className={styles.container}>
        <HomeSectionTitle sectionIndex={displayOrder} seeMoreLink={seeMoreLink} showSeeMoreButton={list.length > 1}>
          {title}
        </HomeSectionTitle>
        <ScrollContainer>
          <NewArrivalProductList sectionIndex={displayOrder} list={list} sectionName={title} />
        </ScrollContainer>
      </div>
      <StyledDivider height="0.1rem" backgroundColor={GlobalColorEnum.Gray70} />
    </>
  )
}
